import type { BriefingConfig } from "@app/toolkit/_shared/types";

/**
 * Bindings that turn the shared briefing engine into the Potentialanalyse.
 *
 * `route` is set because this questionnaire is a service offer, not a toolkit
 * template: the page lives under /services and the SEO entry, JSON-LD and
 * breadcrumb all key on that path. `id` and `storageKey` are contracts —
 * changing them orphans drafts and breaks re-import of exported files.
 */
export const POTENTIAL_CONFIG: BriefingConfig = {
  id: "agentic-bi-potentialanalyse",
  route: "/services/agentic-bi-potentialanalyse",
  filenamePrefix: "dbi-potentialanalyse",
  storageKey: "dbi-potentialanalyse-draft-v1",
  metaMap: {
    company: "unternehmen",
    // No report name in this questionnaire: the company identifies the file.
    reportName: "",
    contactName: "ansprechpartner",
    contactEmail: "kontaktmail",
  },
  // Shares the briefings' route: same Slack webhook, same consent model. The
  // payload's `briefing` field tells the questionnaires apart downstream.
  sendEndpoint: "/api/design-briefing",
  foreignFileError: "Diese Datei stammt nicht aus der Agentic-BI-Potentialanalyse.",
  plainTextTitle: "Agentic-BI-Potentialanalyse",
};
